export const isPurchasable = (piece) => Boolean(piece?.purchasable && piece?.price_usd);

export const formatPrice = (piece) =>
  isPurchasable(piece)
    ? new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(piece.price_usd)
    : "Price Upon Request";
